module.exports = __webpack_public_path__ + "static/img/case.a1398e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/case.jpg
// module id = wTBO
// module chunks = 2